export default __webpack_public_path__ + "static/media/planquiero.99b18471.png";